import React, { useState } from 'react';
import {
  GetARateQuery,
  useCloneARateMutation,
  // useCreateClientRateMutation,
  useCreateVehiclePriceConditionMutation,
  useCreateVehiclePriceVariableMutation,
  useDeleteARateMutation,
  useDeleteVehiclePriceConditionMutation,
  useDeleteVehiclePriceVariableMutation,
  useGetAllClientsQuery,
  // useGetGlobalRateQuery,
  useGetRatesQuery,
  useUpdateServiceSubtypeMutation,
  useUpdateVehiclePriceConditionMutation,
  useUpdateVehiclePriceVariableMutation,
  useGetVehicleBrandModelsQuery,
  useVehicleTypesQuery,
  GetVehicleBrandModelsQuery,
  VehicleTypesQuery,
} from '../../graphql/datamodel.gen';
import { getClient } from '../../apollo';
import { Form, Icon as LegacyIcon } from '@ant-design/compatible';
import {
  CopyOutlined,
  DeleteOutlined,
  ReloadOutlined,
} from '@ant-design/icons';
import '@ant-design/compatible/assets/index.css';
import {
  Alert,
  Button,
  Descriptions,
  Divider,
  Drawer,
  Input,
  InputNumber,
  Modal,
  Select,
  Table,
  Typography,
  Tabs,
  Popconfirm,
  Skeleton,
  Row,
  Col,
  Switch,
  Space,
  message,
  Tag,
  Tooltip,
} from 'antd';
import { capitalizeFirstChar } from '../../utils/string';
import { FormComponentProps } from '@ant-design/compatible/lib/form';
import { cloneDeep } from 'lodash';
import { Client } from '../clients/types';
import { clientSearchFunction } from '../../utils/search';
import { nullIfUndefined } from '../../utils/form';
import VehicleCategories from './VehicleCategories/VehicleCategories';
import { NetworkStatus } from '@apollo/client';
import moment from 'moment';
import { SingleRateModal } from './singleRateModal';
const { TabPane } = Tabs;

type ServiceSubtype =
  GetARateQuery['rate']['serviceTypes'][number]['subtypes'][number];

interface SubtypeModalProps {
  visible: boolean;
  onClose: () => void;
  subtype?: ServiceSubtype;
  rateId: string;
}

interface PriceTableModalProps {
  visible: boolean;
  onClose: () => void;
  subtype?: ServiceSubtype;
  refreshRate: () => any;
  clientId?: string;
  rateId: string;
}

interface ISubtypeForm extends FormComponentProps {
  subtype: ServiceSubtype;
  onSubmit: (data: ISubtypeFormValues) => any;
}

interface ISubtypeFormState {
  conditionType: 'DISTANCE' | 'TIME';
  threshold: number;
}

interface IVehiclePriceModal {
  visible: boolean;
  onClose: () => any;
  vehiclePriceFilter?: ServiceSubtype['priceConditions']['vehicle'][number];
  serviceSubtypeId: string;
  clientId?: string;
  rateId: string;
}

interface VariablesModalProps {
  visible: boolean;
  onClose: () => any;
  variable?: GetARateQuery['rate']['vehiclePriceVariables'][number];
  rateId: string;
  clientId?: string;
}

interface VariablesFormProps extends FormComponentProps {
  variable?: GetARateQuery['rate']['vehiclePriceVariables'][number];
  types: VehicleTypesQuery['vehicleTypes'];
  models: GetVehicleBrandModelsQuery['vehicleBrandModels'][number]['models'];
  brands: GetVehicleBrandModelsQuery['vehicleBrandModels'];
  onSubmit: (data: IVariablesFormValues) => any;
}

interface VariablesFormState {
  validationError?: string;
}

interface IVariablesFormValues {
  id?: string;
  vehicleTypeId?: string;
  vehicleModelId?: string;
  vehicleBrandId?: string;
  numPassengers?: number;
  extraKm?: number;
  extraToll?: number;
  extraHourPrice?: number;
  airport?: number;
  parkingMontserrat?: number;
}

class VariablesForm extends React.Component<
  VariablesFormProps,
  VariablesFormState
> {
  state = {
    validationError: undefined,
  };

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values: IVariablesFormValues) => {
      if (!err) {
        if (
          !values.vehicleTypeId &&
          !values.vehicleBrandId &&
          !values.vehicleModelId
        ) {
          return this.setState({
            validationError:
              'Debes seleccionar almenos un desplegable: un tipo, marca o modelo (o los tres)',
          });
        }

        this.props.onSubmit({
          extraHourPrice: values.extraHourPrice,
          vehicleModelId: nullIfUndefined(values.vehicleModelId),
          vehicleTypeId: nullIfUndefined(values.vehicleTypeId),
          parkingMontserrat: values.parkingMontserrat,
          numPassengers: values.numPassengers,
          extraToll: values.extraToll,
          extraKm: values.extraKm,
          airport: values.airport,
          id: this.props.variable?.id,
          vehicleBrandId: nullIfUndefined(values.vehicleBrandId),
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form
        id={'variables-form'}
        layout={'vertical'}
        onSubmit={this.handleSubmit}
      >
        <Form.Item label={'Tipo'}>
          {getFieldDecorator('vehicleTypeId', {
            initialValue: this.props.variable?.vehicleTypeId,
          })(
            <Select allowClear={true} placeholder={'Selecciona un tipo'}>
              {this.props.types.map((type) => {
                return (
                  <Select.Option key={type.id} value={type.id}>
                    {type.name.toUpperCase()}
                  </Select.Option>
                );
              })}
            </Select>,
          )}
        </Form.Item>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Form.Item label={'Marca'} style={{ flex: 1, marginRight: '15px' }}>
            {getFieldDecorator('vehicleBrandId', {
              initialValue: this.props.variable?.vehicleBrandId,
            })(
              <Select allowClear={true} placeholder={'Selecciona una marca'}>
                {this.props.brands.map((brand) => {
                  return (
                    <Select.Option key={brand.id} value={brand.id}>
                      {brand.brand.toUpperCase()}
                    </Select.Option>
                  );
                })}
              </Select>,
            )}
          </Form.Item>
          <Form.Item label={'Modelo'} style={{ flex: 1 }}>
            {getFieldDecorator('vehicleModelId', {
              initialValue: this.props.variable?.vehicleModelId,
            })(
              <Select allowClear={true} placeholder={'Selecciona un modelo'}>
                {this.props.models.map((model) => {
                  return (
                    <Select.Option key={model.id} value={model.id}>
                      {model.name.toUpperCase()}
                    </Select.Option>
                  );
                })}
              </Select>,
            )}
          </Form.Item>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Form.Item
            label={'Capacidad (PAX)'}
            style={{ flex: 1, marginRight: '15px' }}
          >
            {getFieldDecorator('numPassengers', {
              initialValue: this.props.variable?.paxNumber || 0,
            })(<InputNumber min={0} step={1} />)}
          </Form.Item>
          <Form.Item label={'Kilómetro extra'} style={{ flex: 1 }}>
            {getFieldDecorator('extraKm', {
              initialValue: this.props.variable?.extraPricePerKm || 0,
            })(<InputNumber min={0} step={0.1} />)}
            {' €'}
          </Form.Item>
        </div>

        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Form.Item label={'Peaje'} style={{ flex: 1, marginRight: '15px' }}>
            {getFieldDecorator('extraToll', {
              initialValue: this.props.variable?.tollPricePerKm || 0,
            })(<InputNumber min={0} step={0.1} />)}
            {' €'}
          </Form.Item>
          <Form.Item label={'Asistencia Aeropuerto'} style={{ flex: 1 }}>
            {getFieldDecorator('airport', {
              initialValue: this.props.variable?.airportPrice || 0,
            })(<InputNumber min={0} step={0.1} />)}
            {' €'}
          </Form.Item>
        </div>
        <div style={{ display: 'flex', flexDirection: 'row' }}>
          <Form.Item
            label={'Parking Montserrat'}
            style={{ flex: 1, marginRight: '15px' }}
          >
            {getFieldDecorator('parkingMontserrat', {
              initialValue: this.props.variable?.parkingMontserrat || 0,
            })(<InputNumber min={0} step={0.1} />)}
            {' €'}
          </Form.Item>
          <Form.Item label={'Hora extra'} style={{ flex: 1 }}>
            {getFieldDecorator('extraHourPrice', {
              initialValue: this.props.variable?.extraHourPrice || 0,
            })(<InputNumber min={0} step={0.1} />)}
            {' €'}
          </Form.Item>
        </div>
        {this.state.validationError && (
          <Form.Item>
            <Alert
              type={'error'}
              description={this.state.validationError}
              message={'Error de validación'}
            />
          </Form.Item>
        )}
      </Form>
    );
  }
}

const MyVariablesForm = Form.create<VariablesFormProps>()(VariablesForm);

const VariablesModal: React.FC<VariablesModalProps> = (
  props: VariablesModalProps,
) => {
  const vehicleTypesQuery = useVehicleTypesQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const vehicleBrandModelsQuery = useGetVehicleBrandModelsQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const [createVehiclePriceVariableMut] = useCreateVehiclePriceVariableMutation(
    {
      client: getClient(),
    },
  );

  const [updateVehiclePriceVariableMut] = useUpdateVehiclePriceVariableMutation(
    {
      client: getClient(),
    },
  );

  const brands = vehicleBrandModelsQuery?.data?.vehicleBrandModels || [];
  const allModels = [];
  const types = vehicleTypesQuery?.data?.vehicleTypes;

  brands.map((brand) => {
    allModels.push(...(brand.models || []));
  });

  const onSubmit = async (data: IVariablesFormValues) => {
    // try {
    //   if (!data.id) {
    //     // Create
    //     await createVehiclePriceVariableMut({
    //       variables: {
    //         rateId: props.rateId,
    //         airportPrice: data.airport,
    //         extraKmPrice: data.extraKm,
    //         extraHourPrice: data.extraHourPrice,
    //         extraTollPrice: data.extraToll,
    //         numPassengers: data.numPassengers,
    //         parkingMontserratPrice: data.parkingMontserrat,
    //         vehicleTypeId: data.vehicleTypeId,
    //         vehicleBrandId: data.vehicleBrandId,
    //         vehicleModelId: data.vehicleModelId,
    //       },
    //       update: (proxy, mutationResult) => {
    //         try {
    //           const previousData = getClient().readQuery<
    //             GetGlobalRateQuery,
    //             GetGlobalRateQueryVariables
    //           >({
    //             query: GetGlobalRateDocument,
    //             variables: {
    //               clientId: props.clientId,
    //             },
    //           });
    //           const updatedRate = cloneDeep({
    //             ...previousData.globalRate,
    //             vehiclePriceVariables: [
    //               ...previousData.globalRate.vehiclePriceVariables,
    //               mutationResult.data?.createVehiclePriceVariable,
    //             ],
    //           });
    //           getClient().writeQuery<
    //             GetGlobalRateQuery,
    //             GetGlobalRateQueryVariables
    //           >({
    //             query: GetGlobalRateDocument,
    //             data: {
    //               globalRate: updatedRate,
    //             },
    //           });
    //           // @ts-ignore
    //           getClient().queryManager.broadcastQueries();
    //         } catch (e) {
    //           console.error(e);
    //         }
    //       },
    //     });
    //   } else {
    //     // Create
    //     await updateVehiclePriceVariableMut({
    //       variables: {
    //         id: data.id,
    //         airportPrice: data.airport,
    //         extraKmPrice: data.extraKm,
    //         extraTollPrice: data.extraToll,
    //         extraHourPrice: data.extraHourPrice,
    //         numPassengers: data.numPassengers,
    //         parkingMontserratPrice: data.parkingMontserrat,
    //         vehicleTypeId: data.vehicleTypeId,
    //         vehicleBrandId: data.vehicleBrandId,
    //         vehicleModelId: data.vehicleModelId,
    //       },
    //     });
    //   }
    //   props.onClose();
    // } catch (e) {
    //   console.error(
    //     'Error when creating or updating vehicle price variable',
    //     e,
    //   );
    // }
  };

  return (
    <Modal
      title={
        props.variable ? 'Gestionar configuración' : 'Añadir configuración'
      }
      footer={[
        <Button danger onClick={props.onClose} style={{ float: 'left' }}>
          {props.variable ? 'Cerrar sin guardar' : 'Cerrar'}
        </Button>,
        <Button type={'primary'} htmlType={'submit'} form={'variables-form'}>
          {props.variable ? 'Guardar cambios' : 'Añadir'}
        </Button>,
      ]}
      onCancel={props.onClose}
      visible={props.visible}
      centered={true}
      closable={true}
      // maskClosable={true}
      // forceRender={true}
      destroyOnClose={true}
    >
      <MyVariablesForm
        {...props}
        onSubmit={onSubmit}
        types={types}
        models={allModels}
        brands={brands}
      />
    </Modal>
  );
};

interface VehiclePriceFormContainerProps extends IVehiclePriceModal {
  serviceSubtypeId: string;
  clientId?: string;
  rateId: string;
}

const VehiclePriceFormContainer: React.FC<VehiclePriceFormContainerProps> = (
  props: VehiclePriceFormContainerProps,
) => {
  const vehicleTypesQuery = useVehicleTypesQuery({
    client: getClient(),
  });

  const vehicleBrandModelsQuery = useGetVehicleBrandModelsQuery({
    client: getClient(),
  });

  const vehicleTypes = vehicleTypesQuery.data?.vehicleTypes || [];
  const vehicleBrandModels =
    vehicleBrandModelsQuery.data?.vehicleBrandModels || [];

  const [updateVehiclePriceConditionMut] =
    useUpdateVehiclePriceConditionMutation({
      client: getClient(),
    });

  const [createVehiclePriceConditionMut] =
    useCreateVehiclePriceConditionMutation({
      client: getClient(),
    });

  const updateVehiclePriceCondition = async (
    data: IVehiclePriceFormValues & {
      id?: string;
      vehicleModelId?: string;
      vehicleBrandId?: string;
      vehicleTypeId?: string;
    },
  ) => {
    if (data.id) {
      await updateVehiclePriceConditionMut({
        variables: {
          description: data.description,
          id: data.id,
          name: data.name,
          numPassengers: data.numPassengers,
          price: data.price,
          extraHourPrice: data.extraHourPrice,
          vehicleBrandId: data.vehicleBrandId,
          vehicleModelId: data.vehicleModelId,
          vehicleTypeId: data.vehicleTypeId,
        },
      });
      props.onClose();
    } else {
      await createVehiclePriceConditionMut({
        variables: {
          rateId: props.rateId,
          serviceSubtypeId: props.serviceSubtypeId,
          description: data.description,
          name: data.name,
          numPassengers: data.numPassengers,
          price: data.price,
          extraHourPrice: data.extraHourPrice,
          vehicleBrandId: data.vehicleBrandId,
          vehicleModelId: data.vehicleModelId,
          vehicleTypeId: data.vehicleTypeId,
        },
      });
      props.onClose();
    }

    // update
  };

  return (
    <MyVehiclePriceForm
      vehiclePriceFilter={props.vehiclePriceFilter}
      onSubmit={updateVehiclePriceCondition}
      vehicleTypes={vehicleTypes}
      vehicleBrandModels={vehicleBrandModels}
    />
  );
};

interface IVehiclePriceForm extends FormComponentProps {
  vehicleTypes: VehicleTypesQuery['vehicleTypes'];
  vehicleBrandModels: GetVehicleBrandModelsQuery['vehicleBrandModels'];
  onSubmit: (
    data: IVehiclePriceFormValues & {
      id?: string;
      vehicleModelId?: string;
      vehicleBrandId?: string;
      vehicleTypeId?: string;
    },
  ) => any;
  vehiclePriceFilter?: ServiceSubtype['priceConditions']['vehicle'][number];
}

interface IVehiclePriceFormState {
  selectedVehicleBrandId?: string;
  selectedVehicleModelId?: string;
  selectedVehicleTypeId?: string;
  validationError?: string;
}

interface IVehiclePriceFormValues {
  numPassengers: number;
  price: number;
  extraHourPrice?: number;
  description: string;
  name: string;
  vehicleBrandId?: string;
  vehicleModelId?: string;
  vehicleTypeId: string;
}

class VehiclePriceForm extends React.Component<
  IVehiclePriceForm,
  IVehiclePriceFormState
> {
  state = {
    selectedVehicleBrandId: undefined,
    selectedVehicleModelId: undefined,
    selectedVehicleTypeId: undefined,
    validationError: undefined,
  };

  constructor(props: Readonly<IVehiclePriceForm>) {
    super(props);

    this.state = {
      selectedVehicleBrandId: this.props.vehiclePriceFilter?.vehicleBrandId,
      selectedVehicleModelId: this.props.vehiclePriceFilter?.vehicleModelId,
      selectedVehicleTypeId: this.props.vehiclePriceFilter?.vehicleTypeId,
      validationError: undefined,
    };
  }

  static getDerivedStateFromProps(
    nextProps: IVehiclePriceForm,
    previousState: IVehiclePriceFormState,
  ): IVehiclePriceFormState | null {
    return {
      ...previousState,
      selectedVehicleBrandId: nextProps.vehiclePriceFilter?.vehicleBrandId,
      selectedVehicleModelId: nextProps.vehiclePriceFilter?.vehicleModelId,
      selectedVehicleTypeId: nextProps.vehiclePriceFilter?.vehicleTypeId,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.form.validateFields((err, values: IVehiclePriceFormValues) => {
      if (!err) {
        if (values.price === 0) {
          return this.setState({
            validationError: 'El precio no puede ser cero',
          });
        }
        if (
          !this.state.selectedVehicleModelId &&
          !this.state.selectedVehicleModelId &&
          !this.state.selectedVehicleTypeId
        ) {
          this.setState({
            validationError:
              'Debes seleccionar almenos un tipo y/o marca y/o modelo de vehículo',
          });
        }
        this.setState({
          validationError: undefined,
        });

        this.props.onSubmit({
          name: values.name,
          id: this.props.vehiclePriceFilter?.id,
          description: values.description,
          numPassengers: values.numPassengers,
          price: values.price,
          extraHourPrice: values.extraHourPrice,
          vehicleModelId: nullIfUndefined(values.vehicleModelId),
          vehicleTypeId: nullIfUndefined(values.vehicleTypeId),
          vehicleBrandId: nullIfUndefined(values.vehicleBrandId),
        });
      }
    });
  };

  render() {
    const allModels = [];

    const { getFieldDecorator } = this.props.form;

    this.props.vehicleBrandModels.map((brand) => {
      allModels.push(...(brand.models || []));
    });

    const models: GetVehicleBrandModelsQuery['vehicleBrandModels'][number]['models'] =
      this.props.vehicleBrandModels.find(
        (brand) => brand.id === this.state.selectedVehicleBrandId,
      )?.models || allModels;

    return (
      <Form
        id={'vehicle-price-form'}
        onSubmit={this.handleSubmit}
        layout="vertical"
      >
        <Form.Item label={'Nombre'} required>
          {this.props.form.getFieldDecorator('name', {
            initialValue: this.props.vehiclePriceFilter?.name,
            rules: [
              {
                required: true,
                message: 'Por favor, introduce un nombre',
              },
            ],
          })(<Input />)}
        </Form.Item>
        <Form.Item label={'Descripción'}>
          {this.props.form.getFieldDecorator('description', {
            initialValue: this.props.vehiclePriceFilter?.description,
          })(<Input />)}
        </Form.Item>
        <Form.Item label={'Tipo'} required>
          {getFieldDecorator('vehicleTypeId', {
            initialValue: this.props.vehiclePriceFilter?.vehicleTypeId,
            rules: [
              {
                required: true,
                message: 'Por favor, selecciona un tipo de vehículos',
              },
            ],
          })(
            <Select
              placeholder={this.props.vehicleTypes
                .map((type) => type.name.toUpperCase())
                .join(', ')}
              allowClear={true}
            >
              {this.props.vehicleTypes.map((type) => {
                return (
                  <Select.Option key={type.id} value={type.id}>
                    {type.name.toUpperCase()}
                  </Select.Option>
                );
              })}
            </Select>,
          )}
        </Form.Item>
        <Row>
          <Col span={12}>
            <Form.Item label={'Marca'} style={{ flex: 1, marginRight: '15px' }}>
              {getFieldDecorator('vehicleBrandId', {
                initialValue: this.props.vehiclePriceFilter?.vehicleBrandId,
              })(
                <Select allowClear={true} placeholder={'Selecciona una marca'}>
                  {this.props.vehicleBrandModels.map((brandModels) => {
                    return (
                      <Select.Option
                        key={brandModels.id}
                        value={brandModels.id}
                      >
                        {brandModels.brand.toUpperCase()}
                      </Select.Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={'Modelo'} style={{ flex: 1 }}>
              {getFieldDecorator('vehicleModelId', {
                initialValue: this.props.vehiclePriceFilter?.vehicleModelId,
              })(
                <Select allowClear={true} placeholder={'Selecciona un modelo'}>
                  {models.map((model) => {
                    return (
                      <Select.Option key={model.id} value={model.id}>
                        {model.name.toUpperCase()}
                      </Select.Option>
                    );
                  })}
                </Select>,
              )}
            </Form.Item>
          </Col>
        </Row>

        <Row>
          <Col span={12}>
            <Form.Item label={'Capacidad (# Pasajeros)'} required>
              {this.props.form.getFieldDecorator('numPassengers', {
                initialValue: this.props.vehiclePriceFilter?.numPassengers || 0,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, introduce la capacidad (# pasajeros)',
                  },
                ],
              })(<InputNumber min={0} />)}{' '}
            </Form.Item>
          </Col>
          <Col span={12}></Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item label={'Precio base'} required>
              {this.props.form.getFieldDecorator('price', {
                initialValue: this.props.vehiclePriceFilter?.basePrice || 0,
                rules: [
                  {
                    required: true,
                    message: 'Por favor, introduce un precio',
                  },
                ],
              })(
                <InputNumber decimalSeparator={','} min={0} step={0.1} />,
              )}{' '}
              <Typography.Text strong={true}> €</Typography.Text>
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={'Hora extra'}>
              {this.props.form.getFieldDecorator('extraHourPrice', {
                initialValue:
                  this.props.vehiclePriceFilter?.extraHourPrice || 0,
                rules: [
                  {
                    required: false,
                    message: 'Por favor, introduce un precio',
                  },
                ],
              })(
                <InputNumber decimalSeparator={','} min={0} step={0.1} />,
              )}{' '}
              <Typography.Text strong={true}> €</Typography.Text>
            </Form.Item>
          </Col>
        </Row>

        {this.state.validationError && (
          <Alert
            description={this.state.validationError}
            message={'Error de validación'}
            type="error"
          />
        )}
      </Form>
    );
  }
}

const MyVehiclePriceForm = Form.create<IVehiclePriceForm>()(VehiclePriceForm);

const VehiclePriceModal: React.FC<IVehiclePriceModal> = (
  props: IVehiclePriceModal,
) => {
  return (
    <Modal
      footer={[
        <Button danger onClick={props.onClose} style={{ float: 'left' }}>
          Cerrar sin guardar
        </Button>,
        <Button
          htmlType={'submit'}
          form={'vehicle-price-form'}
          type={'primary'}
          icon={<LegacyIcon type={'plus'} />}
        >
          {props.vehiclePriceFilter ? 'Guardar' : 'Añadir'}
        </Button>,
      ]}
      width={400}
      title={
        props.vehiclePriceFilter
          ? 'Gestionar precio de vehículo'
          : 'Añadir nuevo precio de vehículo'
      }
      onCancel={props.onClose}
      visible={props.visible}
      centered={true}
      maskClosable={true}
      destroyOnClose={true}
      forceRender={true}
    >
      <VehiclePriceFormContainer
        {...props}
        vehiclePriceFilter={props.vehiclePriceFilter}
      />
    </Modal>
  );
};

interface ISubtypeFormValues {
  name: string;
  description?: string;
  threshold: number;
}

class SubtypeForm extends React.Component<ISubtypeForm, ISubtypeFormState> {
  state = {
    conditionType: undefined,
    threshold: undefined,
  };

  constructor(props: Readonly<ISubtypeForm>) {
    super(props);

    this.state = {
      conditionType: props.subtype.fulfillingCondition.conditionType,
      threshold: props.subtype.fulfillingCondition.threshold,
    };
  }

  handleSubmit = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values: ISubtypeFormValues) => {
      if (!err) {
        this.props.onSubmit({
          description: values.description,
          name: values.name,
          threshold: values.threshold,
        });
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;

    const localizedConditionType =
      this.state.conditionType === 'DISTANCE'
        ? 'distancia'
        : this.state.conditionType === 'TIME'
        ? 'duración'
        : this.state.conditionType === 'LOCATION'
        ? 'localización'
        : '';

    const units =
      this.state.conditionType === 'DISTANCE'
        ? 'Km'
        : this.state.conditionType === 'TIME'
        ? 'horas'
        : '';

    const value =
      this.state.conditionType === 'DISTANCE'
        ? this.state.threshold / 1000
        : this.state.conditionType === 'TIME'
        ? this.state.threshold / 3600
        : undefined;

    return (
      <Form
        id={'update-subtype-form'}
        onSubmit={this.handleSubmit}
        layout="vertical"
      >
        <Row>
          <Col span={12}>
            <Form.Item
              style={{ marginRight: '15px' }}
              label={'Nombre del subtipo'}
              required={true}
            >
              {getFieldDecorator('name', {
                initialValue: this.props.subtype.name,
                rules: [
                  {
                    required: true,
                    message: 'Por favor introduce un nombre para el subtipo',
                  },
                ],
              })(<Input />)}
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item label={'Descripción'} style={{ flex: 1 }}>
              {getFieldDecorator('description', {
                initialValue: this.props.subtype.description,
                rules: [
                  {
                    required: false,
                  },
                ],
              })(<Input.TextArea />)}
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            <Form.Item
              style={{ marginRight: '15px' }}
              label={'Tipo de condición'}
              required={true}
            >
              {getFieldDecorator('conditionType', {
                initialValue: this.state.conditionType,
                rules: [
                  {
                    required: false,
                  },
                ],
              })(
                <Select
                  disabled={true}
                  onChange={(value) => {
                    this.setState({
                      conditionType: value as 'DISTANCE' | 'TIME',
                    });
                  }}
                >
                  <Select.Option key={'DISTANCE'} value={'DISTANCE'}>
                    Distancia (Kilómetros)
                  </Select.Option>
                  <Select.Option key={'TIME'} value={'TIME'}>
                    Duración (horas)
                  </Select.Option>
                  <Select.Option key={'LOCATION'} value={'LOCATION'}>
                    Localización
                  </Select.Option>
                </Select>,
              )}
            </Form.Item>
          </Col>
          <Col span={12}>
            {this.state.conditionType === 'DISTANCE' && (
              <Form.Item
                label={capitalizeFirstChar(localizedConditionType)}
                required={true}
              >
                {getFieldDecorator('threshold', {
                  initialValue: value,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                  // @ts-ignore
                })(
                  <InputNumber
                    addonBefore="Hasta"
                    min={1}
                    addonAfter={units}
                  />,
                )}{' '}
              </Form.Item>
            )}
          </Col>
        </Row>
        <Row>
          <Col span={12}>
            {this.props.subtype.hours > 0 && (
              <Form.Item label={capitalizeFirstChar('horas')} required={true}>
                {getFieldDecorator('hours', {
                  initialValue: this.props.subtype.hours,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                  // @ts-ignore
                })(
                  <InputNumber
                    addonBefore="Minimo"
                    disabled
                    min={1}
                    addonAfter={'horas'}
                  />,
                )}{' '}
              </Form.Item>
            )}
          </Col>
          <Col span={12}>
            {this.props.subtype.dinner && (
              <Form.Item label={capitalizeFirstChar('cena')} required={true}>
                {getFieldDecorator('dinner', {
                  initialValue: this.props.subtype.dinner,
                  rules: [
                    {
                      required: false,
                    },
                  ],
                  // @ts-ignore
                })(
                  <Switch checked={this.props.subtype.dinner} disabled />,
                )}{' '}
              </Form.Item>
            )}
          </Col>
        </Row>
      </Form>
    );
  }
}

const MySubtypeForm = Form.create<ISubtypeForm>()(SubtypeForm);

const SubtypeModal: React.FC<SubtypeModalProps> = (
  props: SubtypeModalProps,
) => {
  const [loading, setLoading] = useState(false);

  const [updateServiceSubtypeMut] = useUpdateServiceSubtypeMutation({
    client: getClient(),
  });

  const footerButtons = [
    <Button danger style={{ float: 'left' }} onClick={props.onClose}>
      Cerrar sin guardar
    </Button>,
    <Button
      loading={loading}
      form="update-subtype-form"
      key="submit"
      htmlType="submit"
      type={'primary'}
    >
      Guardar cambios
    </Button>,
  ];

  const updateRate = async (data: ISubtypeFormValues) => {
    // Update it
    try {
      setLoading(true);
      await updateServiceSubtypeMut({
        variables: {
          id: props.subtype.id,
          description: data.description,
          distanceInMeters: data.threshold * 1000,
          name: data.name,
          rateId: props.rateId,
        },
      });
      props.onClose();
    } catch (e) {
      console.error('Error updating Service Subtype', e);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      title={`Subtipo de servicio: ${props.subtype?.name}`}
      width={800}
      afterClose={props.onClose}
      okText={'Cerrar'}
      onCancel={props.onClose}
      onOk={props.onClose}
      footer={footerButtons}
      visible={props.visible}
      centered={true}
      destroyOnClose={false}
      forceRender={true}
    >
      {props.subtype && (
        <MySubtypeForm subtype={props.subtype} onSubmit={updateRate} />
      )}
    </Modal>
  );
};

const PricesTableModal: React.FC<PriceTableModalProps> = (
  props: PriceTableModalProps,
) => {
  const [addVehiclePriceFilterVisible, setAddVehiclePriceFilterVisible] =
    useState(false);

  const [modifyVehiclePriceFilterVisible, setModifyVehiclePriceFilterVisible] =
    useState(false);
  const [vehiclePriceFilter, setVehiclePriceFilter] = useState(undefined);

  const vehicleTypesQuery = useVehicleTypesQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const [deleteVehiclePriceCondition] = useDeleteVehiclePriceConditionMutation({
    client: getClient(),
  });

  const vehicleBrandModelsQuery = useGetVehicleBrandModelsQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const allModels = [];

  vehicleBrandModelsQuery?.data?.vehicleBrandModels.forEach((brand) => {
    const { models } = brand;
    allModels.push(...models);
  });

  React.useEffect(() => {
    if (addVehiclePriceFilterVisible) {
      setVehiclePriceFilter(undefined);
    }
  }, [addVehiclePriceFilterVisible]);

  return (
    <Modal
      footer={[
        <Button type={'primary'} onClick={props.onClose}>
          Cerrar
        </Button>,
      ]}
      title={`Gestion de precios de ${props.subtype?.name}`}
      width={1000}
      afterClose={props.onClose}
      onCancel={props.onClose}
      onOk={props.onClose}
      visible={props.visible}
      centered={true}
      destroyOnClose={false}
      forceRender={true}
    >
      <Alert
        message='Si el campo "Hora extra" está vacío, se aplican los valores base establecidos en la pestaña "Según vehículo". Si lo desea, puede utilizar un valor distinto para este subtipo de servicio.'
        type="info"
        showIcon
      />
      <div
        style={{
          marginBottom: '2rem',
          marginTop: '2rem',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        }}
      >
        <h3>Tabla de precios de vehículos</h3>
        <Button
          icon={<LegacyIcon type={'plus'} />}
          onClick={() => {
            setAddVehiclePriceFilterVisible(true);
          }}
        >
          Añadir nuevo
        </Button>
      </div>

      <Table
        size="small"
        columns={[
          {
            title: 'Nombre',
            dataIndex: 'name',
          },
          {
            title: 'Descripción',
            dataIndex: 'description',
          },
          {
            title: 'Tipo',
            key: 'type',
            render: (_: any, record) => {
              if (record.vehicleTypeId) {
                const vehicleType = vehicleTypesQuery.data?.vehicleTypes?.find(
                  (vehicleType) => vehicleType.id === record.vehicleTypeId,
                );

                if (vehicleType) {
                  return vehicleType.name?.toUpperCase();
                }
              }

              return null;
            },
          },
          {
            title: 'Marca',
            key: 'brand',
            render: (_: any, record) => {
              if (record.vehicleBrandId) {
                const vehicleBrand =
                  vehicleBrandModelsQuery.data?.vehicleBrandModels?.find(
                    (vehicleBrand) => vehicleBrand.id === record.vehicleBrandId,
                  );

                if (vehicleBrand) {
                  return vehicleBrand.brand?.toUpperCase();
                }
              }

              return null;
            },
          },
          {
            title: 'Modelo',
            key: 'model',
            render: (_: any, record) => {
              if (record.vehicleModelId) {
                const vehicleModel = allModels?.find(
                  (model) => model.id === record.vehicleModelId,
                );

                if (vehicleModel) {
                  return vehicleModel.name?.toUpperCase();
                }
              }

              return null;
            },
          },
          {
            title: 'Precio base',
            dataIndex: 'basePrice',
            render: (price: number) => {
              return `${price} €`;
            },
          },
          {
            title: 'Hora extra',
            dataIndex: 'extraHourPrice',
            render: (price: number) => {
              return price > 0 ? `${price} €` : undefined;
            },
          },
          {
            title: 'Capacidad (PAX)',
            dataIndex: 'numPassengers',
            render: (capacity: number) => {
              if (capacity === 0) {
                return null;
              }

              return capacity;
            },
          },
          {
            key: 'actions',
            width: 100,
            render: (_: any, record) => {
              return (
                <div style={{ display: 'flex', flexDirection: 'row' }}>
                  <Button
                    icon={<LegacyIcon type={'edit'} />}
                    onClick={() => {
                      setVehiclePriceFilter(record);
                      setModifyVehiclePriceFilterVisible(true);
                    }}
                    style={{ marginRight: '15px' }}
                  >
                    Modificar
                  </Button>
                  <Popconfirm
                    title={'Estás seguro?'}
                    onConfirm={async () => {
                      await deleteVehiclePriceCondition({
                        variables: {
                          id: record.id,
                        },
                      });
                      props.refreshRate();
                    }}
                  >
                    <Button danger>Eliminar</Button>
                  </Popconfirm>
                </div>
              );
            },
          },
        ]}
        dataSource={[...(props.subtype?.priceConditions?.vehicle || [])]}
      />
      <VehiclePriceModal
        key={vehiclePriceFilter?.id}
        clientId={props.clientId}
        rateId={props.rateId}
        serviceSubtypeId={props.subtype?.id}
        vehiclePriceFilter={vehiclePriceFilter}
        visible={
          addVehiclePriceFilterVisible || modifyVehiclePriceFilterVisible
        }
        onClose={() => {
          props.refreshRate();
          setAddVehiclePriceFilterVisible(false);
          setModifyVehiclePriceFilterVisible(false);
        }}
      />
    </Modal>
  );
};

const Rate = () => {
  const [selectedRateId, setSelectedRateId] = useState(undefined);
  // const [createClientRateMut] = useCreateClientRateMutation({
  //   client: getClient(),
  // });

  const clientsQuery = useGetAllClientsQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const vehicleTypesQuery = useVehicleTypesQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const vehicleBrandModelsQuery = useGetVehicleBrandModelsQuery({
    client: getClient(),
    fetchPolicy: 'network-only',
  });

  const [deleteVehiclePriceMut] = useDeleteVehiclePriceVariableMutation({
    client: getClient(),
  });

  const allModels = [];

  vehicleBrandModelsQuery?.data?.vehicleBrandModels.forEach((brand) => {
    const { models } = brand;
    allModels.push(...models);
  });

  // const globalRateQueryResult = useGetGlobalRateQuery({
  //   client: getClient(),
  //   variables: {
  //     clientId: selectedClientId,
  //   },
  //   fetchPolicy: 'network-only',
  // });

  const getRatesQueryResult = useGetRatesQuery({
    client: getClient(),
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const [cloneRateMutation, { loading: loadingCloneRate }] =
    useCloneARateMutation({
      client: getClient(),
    });

  const [deleteRateMutation] = useDeleteARateMutation({
    client: getClient(),
  });

  // const rateId = globalRateQueryResult?.data?.globalRate?.id;

  // const subtypes =
  //   globalRateQueryResult.data?.globalRate?.serviceTypes?.find(
  //     (serviceType) => serviceType.id === selectedServiceType,
  //   )?.subtypes || [];

  // const types =
  //   globalRateQueryResult?.data?.globalRate?.serviceTypes?.filter(
  //     (type) => type.subtypes?.length,
  //   ) || [];

  // const selectedSubtype = subtypes.find(
  //   (subtype) => subtype.id === selectedServiceSubType,
  // );

  const cloneRate = (rateToCloneId: string) => {
    const rateToClone = getRatesQueryResult.data?.rates?.find(
      (r) => r.id === rateToCloneId,
    );

    message.loading({ content: 'Clonando tarifario', key: 'cloning-rate' }, 0);

    cloneRateMutation({
      variables: {
        rateToClone: rateToCloneId,
        name: `Copia de ${rateToClone?.name}`,
      },
      onCompleted: () => {
        getRatesQueryResult.refetch();
        message.success({
          content: 'Tarifario clonado satisfactoriamente',
          key: 'cloning-rate',
          duration: 4,
        });
      },
    });
  };

  const deleteRate = (rateId: string) => {
    message.loading(
      { content: 'Eliminando tarifario', key: 'deleting-rate' },
      0,
    );

    deleteRateMutation({
      variables: {
        rate: rateId,
      },
      onCompleted: () => {
        getRatesQueryResult.refetch();
        message.success({
          content: 'Tarifario eliminado satisfactoriamente',
          key: 'deleting-rate',
          duration: 4,
        });
      },
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          marginBottom: '1.5rem',
        }}
      >
        <Button
          icon={<ReloadOutlined translate={undefined} />}
          onClick={() => {
            getRatesQueryResult.refetch();
          }}
        >
          Refrescar
        </Button>
      </div>
      <Table
        loading={getRatesQueryResult.networkStatus === NetworkStatus.refetch}
        columns={[
          {
            title: 'Nombre',
            key: 'name',
            dataIndex: 'name',
            render: (value, record) => {
              if (record.isGlobal) {
                return (
                  <Space direction="horizontal">
                    {value}
                    <Tooltip title="Este tarifario se aplicará por defecto a los clientes que todavía no tengan uno asignado. No se puede eliminar">
                      <Tag>Por defecto</Tag>
                    </Tooltip>
                  </Space>
                );
              } else {
                return value;
              }
            },
          },
          {
            title: 'Fecha de creación',
            key: 'createdAt',
            dataIndex: 'createdAt',
            render: (value) => {
              return moment(value).format('DD/MM/YYYY');
            },
            sorter: (recordA, recordB) => {
              return moment(recordA.createdAt).diff(
                moment(recordB.createdAt),
                'minutes',
              );
            },
            defaultSortOrder: 'descend',
          },
          {
            title: 'N. Clientes asignados',
            render(value, record, index) {
              if (record.isGlobal) {
                return null;
              }
              return record.clients.length;
            },
            sorter: (recordA, recordB) => {
              return recordA.clients.length - recordB.clients.length;
            },
          },
          {
            title: 'Acciones',
            key: 'actions',
            fixed: 'right',
            width: 100,
            render: (_, record) => {
              return (
                <Space>
                  <Button
                    onClick={() => {
                      setSelectedRateId(record.id);
                    }}
                  >
                    Gestionar
                  </Button>
                  <Button
                    onClick={() => {
                      cloneRate(record.id);
                    }}
                    icon={<CopyOutlined translate={undefined} />}
                  >
                    Clonar
                  </Button>
                  {!record.isGlobal && (
                    <Popconfirm
                      title={`¿Estás seguro de que deseas eliminar este tarifario? Está asignado a ${record.clients.length} cliente(s)`}
                      okButtonProps={{
                        type: 'primary',
                        danger: true,
                      }}
                      onConfirm={() => {
                        deleteRate(record.id);
                      }}
                      placement="topRight"
                      arrowPointAtCenter
                    >
                      <Button
                        danger
                        type="primary"
                        icon={<DeleteOutlined translate={undefined} />}
                      >
                        Eliminar
                      </Button>
                    </Popconfirm>
                  )}
                </Space>
              );
            },
          },
        ]}
        dataSource={getRatesQueryResult.data?.rates}
      />

      <SingleRateModal
        id={selectedRateId}
        visible={!!selectedRateId}
        onClose={() => {
          getRatesQueryResult.refetch();
          setSelectedRateId(undefined);
        }}
      />

      {/* {globalRateQueryResult.data?.globalRate &&
        !globalRateQueryResult.loading && (
          <Tabs type="card">
            <TabPane tab="Según vehículo" key="1">
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'flex-end',
                  marginBottom: '1rem',
                }}
              >
                <Button
                  type="primary"
                  icon={<LegacyIcon type={'plus'} />}
                  onClick={() => {
                    setVariablesVisible(true);
                  }}
                >
                  Añadir configuración
                </Button>
              </div>
              <Table
                pagination={false}
                bordered
                size="small"
                dataSource={[
                  ...(globalRateQueryResult.data?.globalRate
                    ?.vehiclePriceVariables || []),
                ]}
                columns={[
                  {
                    title: 'Tipo',
                    key: 'type',
                    render: (_: any, record) => {
                      return vehicleTypesQuery?.data?.vehicleTypes
                        ?.find((type) => type.id === record.vehicleTypeId)
                        ?.name?.toUpperCase();
                    },
                  },
                  {
                    title: 'Marca',
                    key: 'brand',
                    render: (_: any, record) => {
                      return vehicleBrandModelsQuery?.data?.vehicleBrandModels
                        ?.find((brand) => brand.id === record.vehicleBrandId)
                        ?.brand?.toUpperCase();
                    },
                  },
                  {
                    title: 'Modelo',
                    key: 'model',
                    render: (_: any, record) => {
                      return allModels
                        .find((model) => model.id === record.vehicleModelId)
                        ?.name?.toUpperCase();
                    },
                  },
                  {
                    title: 'Capacidad (PAX)',
                    dataIndex: 'paxNumber',
                    render: (capacity: number) => {
                      if (capacity === 0) {
                        return null;
                      }

                      return capacity;
                    },
                  },
                  {
                    title: 'Kilómetro extra',
                    dataIndex: 'extraPricePerKm',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                  },
                  {
                    title: 'Peaje extra',
                    dataIndex: 'tollPricePerKm',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                  },
                  {
                    title: 'Asistencia aeropuerto',
                    dataIndex: 'airportPrice',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                  },
                  {
                    title: 'Parking Montserrat',
                    dataIndex: 'parkingMontserrat',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                  },
                  {
                    title: 'Hora extra',
                    dataIndex: 'extraHourPrice',
                    render: (value: number) => {
                      return `${value} €`;
                    },
                  },
                  {
                    title: '',
                    key: 'actions',
                    render: (_: any, record) => {
                      return (
                        <div style={{ display: 'flex', flexDirection: 'row' }}>
                          <Button
                            style={{ marginRight: '15px' }}
                            onClick={() => {
                              setVariable(record);
                              setVariablesVisible(true);
                            }}
                          >
                            Gestionar
                          </Button>
                          <Popconfirm
                            title={'Estás seguro?'}
                            onConfirm={() => {
                              return deleteVehiclePriceMut({
                                variables: {
                                  id: record.id,
                                },
                                update: (proxy, mutationResult) => {
                                  try {
                                    const previousData = getClient().readQuery<
                                      GetGlobalRateQuery,
                                      GetGlobalRateQueryVariables
                                    >({
                                      query: GetGlobalRateDocument,
                                      variables: {
                                        clientId: selectedClientId,
                                      },
                                    });

                                    const updatedRate = cloneDeep({
                                      ...previousData.globalRate,
                                      vehiclePriceVariables:
                                        previousData.globalRate.vehiclePriceVariables.filter(
                                          (pv) => pv.id !== record.id,
                                        ),
                                    });

                                    getClient().writeQuery<
                                      GetGlobalRateQuery,
                                      GetGlobalRateQueryVariables
                                    >({
                                      query: GetGlobalRateDocument,
                                      data: {
                                        globalRate: updatedRate,
                                      },
                                    });

                                    // @ts-ignore
                                    getClient().queryManager.broadcastQueries();
                                  } catch (e) {
                                    console.error(e);
                                  }
                                },
                              });
                            }}
                          >
                            <Button danger>Eliminar</Button>
                          </Popconfirm>
                        </div>
                      );
                    },
                  },
                ]}
              />
            </TabPane>
            <TabPane tab="Según tipo de servicio" key="2">
              <Row>
                <Col span={8}>
                  <Table
                    bordered
                    pagination={false}
                    size="small"
                    rowSelection={{
                      fixed: true,
                      type: 'radio',
                      onSelect: (record) => {
                        setSelectedServiceType(record.id);
                      },
                      selectedRowKeys: [selectedServiceType],
                    }}
                    onRow={(record) => ({
                      onClick: () => {
                        setSelectedServiceType(record.id);
                      },
                    })}
                    columns={[
                      {
                        title: 'Tipo de servicio',
                        dataIndex: 'name',
                      },
                      {
                        title: 'Descripción',
                        dataIndex: 'description',
                      },
                      {
                        title: 'Subtipos',
                        render: (_: any, record) => {
                          return record.subtypes?.length || 0;
                        },
                      },
                    ]}
                    dataSource={[...types].map((t) => ({ ...t, key: t.id }))}
                  />
                </Col>
                <Col span={16}>
                  <Table
                    // onRowClick={record => {
                    //   setSelectedServiceSubType(record.id);
                    // }}
                    bordered
                    style={{ marginLeft: '15px' }}
                    pagination={false}
                    size="small"
                    // emptyText="Selecciona un tipo de servicio primero"
                    columns={[
                      {
                        title: 'Subtipo',
                        dataIndex: 'name',
                      },
                      {
                        title: 'Descripción',
                        dataIndex: 'description',
                      },
                      {
                        title: '',
                        key: 'actions',
                        render: (_: any, record) => {
                          return (
                            <>
                              <Button
                                style={{ marginRight: '15px' }}
                                onClick={() => {
                                  setPriceTableVisible(true);
                                  setSelectedServiceSubType(record.id);
                                }}
                                icon={<LegacyIcon type={'euro'} />}
                              >
                                Precios
                              </Button>
                              <Button
                                onClick={() => {
                                  setSelectedServiceSubType(record.id);
                                  setManagementVisible(true);
                                }}
                              >
                                Gestionar
                              </Button>
                            </>
                          );
                        },
                      },
                    ]}
                    dataSource={[...subtypes]}
                  />
                </Col>
              </Row>
            </TabPane>
            <TabPane tab="Categorias de vehículos" key="3">
              <VehicleCategories
                rate={globalRateQueryResult.data?.globalRate}
              />
            </TabPane>
          </Tabs>
        )}
      {!globalRateQueryResult?.loading &&
        !globalRateQueryResult.data?.globalRate && (
          <div>
            <Alert
              type={'info'}
              message={'Tarifario sin asignar'}
              description={
                'Este cliente no tiene un tarifario asignado todavía. Puedes crear\n' +
                '            uno nuevo haciendo click en el botón inferior. Este tarifario\n' +
                '            heredará los datos del tarifario general y podrá ser modificado'
              }
            ></Alert>
            <Button
              loading={createRateLoading}
              onClick={async () => {
                setCreateRateLoading(true);
                await createClientRateMut({
                  variables: {
                    id: selectedClientId,
                  },
                });

                await globalRateQueryResult.refetch({
                  clientId: selectedClientId,
                });
                setCreateRateLoading(false);
              }}
              icon={<LegacyIcon type={'plus'} />}
              style={{ marginTop: '15px' }}
              type={'primary'}
            >
              Crear tarifario
            </Button>
          </div>
        )} */}
      {/* <SubtypeModal
        rateId={rateId}
        visible={managementVisible}
        onClose={() => {
          setManagementVisible(false);
          setSelectedServiceSubType(undefined);
        }}
        subtype={selectedSubtype}
      />
      <PricesTableModal
        clientId={selectedClientId}
        rateId={rateId}
        refreshRate={globalRateQueryResult.refetch}
        visible={priceTableVisible}
        subtype={selectedSubtype}
        onClose={() => {
          setPriceTableVisible(false);
          setSelectedServiceSubType(undefined);
        }}
      />
      <VariablesModal
        clientId={selectedClientId}
        rateId={rateId}
        visible={variablesVisble}
        variable={variable}
        onClose={() => {
          setVariablesVisible(false);
          setVariable(undefined);
        }}
      /> */}
    </div>
  );
};

export default Rate;
